import React from 'react';
import { TransformCTA } from '../TransformCTA';
import { AUTHOR_IMAGE } from '../../data/content';
export function Author() {
  return <section className="w-full bg-ink-950 px-5 py-14 sm:py-20" data-id="element-42" data-mp="1htc5755c1bfo">
      <div className="mx-auto w-full max-w-xl lg:max-w-5xl" data-id="element-43" data-mp="1wgx5kratowjw">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.24em] text-teal-400" data-id="element-44" data-mp="1wii38psfovlz">
          🩺 Meet Dr. Karito
        </p>
        <h2 className="mt-4 text-center font-display text-[26px] font-bold leading-tight text-white sm:text-[34px]" data-id="element-45" data-mp="25gbwfruwj94x">
          Creator of the Male Fertility Route
        </h2>

        <div className="mt-10 lg:grid lg:grid-cols-[minmax(0,320px)_minmax(0,1fr)] lg:items-start lg:gap-10" data-id="element-46" data-mp="2fg2rbundjq5j">
          <figure className="mx-auto w-full max-w-[300px] lg:max-w-none" data-id="element-47" data-mp="2ag6lrqz13qnv">
            <img src={AUTHOR_IMAGE} alt="Portrait of Dr. Karito, creator of the Male Fertility Route" className="w-full rounded-2xl object-cover" loading="lazy" data-id="element-48" data-mp="l1i7fk6vnyn7" />
            <figcaption className="mt-4 text-center lg:text-left" data-id="element-49" data-mp="3gfe11t9t75n0">
              <span className="block text-[15px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-50" data-mp="3kfy052dy0jbs">
                Dr. Karito
              </span>
              <span className="mt-1 block text-[11px] font-semibold uppercase tracking-[0.16em] text-teal-400" data-id="element-51" data-mp="3pdho4u0g0agx">
                Creator of the Male Fertility Route
              </span>
            </figcaption>
          </figure>

          <div className="mt-8 space-y-4 text-[15px] leading-relaxed text-white/70 lg:mt-0 sm:text-base" data-id="element-52" data-mp="31ssmkeu281r">
            <p data-id="element-53" data-mp="c04sze5i4k7e">For years, she observed the same problem repeatedly:</p>
            <p data-id="element-54" data-mp="c0xqdoiklxcv">
              professionals with excellent training and extensive knowledge, but without a clear
              clinical pathway to follow when a patient with male infertility sat in front of them.
            </p>
            <p data-id="element-55" data-mp="2iqm54oau2fr5">
              Not because they lacked ability, but because the information was scattered across
              clinical guidelines, scientific papers, and lengthy textbooks that were difficult to
              consult during a real appointment.
            </p>
            <p className="font-semibold text-white" data-id="element-56" data-mp="3h49lisahndro">
              That is why she created the Male Fertility Route.
            </p>
            <p data-id="element-57" data-mp="3q3d31ru0bl42">
              Not as another manual to study, but as a clinical system designed to transform complex
              information into practical, structured decisions.
            </p>
            <p data-id="element-58" data-mp="3w51z1q4e0du">
              The goal was never to make you memorize more information. The goal is to help you
              approach every patient consultation with a clearer understanding of what to evaluate,
              what to consider, and what the next step should be.
            </p>
          </div>
        </div>

        <TransformCTA headline="Take the method into your next consultation." data-id="element-59" data-mp="rkoclnwn6p93" />
      </div>
    </section>;
}